import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SCAMP_API } from 'src/environments/environment';
import { Empreiteira } from '../../../models/empreiteira.model';
import { AccountService } from '../../../services/account.service';


@Injectable({providedIn: 'root'})
export class EmpreiteiraService {

    constructor(
        private http: HttpClient,
        private account: AccountService
    ) { }


    getEmpreiteiras(): Observable<Empreiteira[]> {
        return this.http.get<Empreiteira[]>(`${SCAMP_API.accountApiV1}/empreiteiras-cb`, {headers : this.account.composeHeaders()});
    }

    create(data: any)  {
        return this.http.post(`${SCAMP_API.accountApiV1}/empreiteira`, data, {headers : this.account.composeHeaders()});
    }

    read(id: number): Observable<any> {
        return this.http.get<any>(`${SCAMP_API.accountApiV1}/empreiteira/${id}`, {headers : this.account.composeHeaders()});
    }


    update(id: number, data: any) {
        return this.http.put(`${SCAMP_API.accountApiV1}/empreiteira/${id}`, data, {headers : this.account.composeHeaders()});
    }

    delete(id: number) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/empreiteira/${id}`, {headers : this.account.composeHeaders()});
    }

    list(): Observable<any[]> {
        return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/empreiteiras`, {headers : this.account.composeHeaders()});
    }

    isUniqueNomeEmpreiteira(nome: string): Observable<boolean> {
        return this.http.post<boolean>(`${SCAMP_API.accountApiV1}/nome-empreiteira-is-unique`, {nome},
        {headers : this.account.composeHeaders()});
    }
}
